import { CancelBtn } from 'components/Button/CancelBtn'
import { Input } from 'components/Input/Input'
import { ToggleButton } from 'components/Input/ToggleButton'
import { NavBar } from 'components/NavBar/NavBar'
import { clearSinglePermissionPolicyTemplate, editRolePermissionPolicyTemplate, getSingleRolePermissionPolicyTemplate } from 'features/roles/roleTemplatesSlice'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { Button, Flex, H1WithBack, H2, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { IPermissionPolicy } from 'types/api/clientRoles.interface'

export const EditRolePermissionPolicyTemplate = () => {

    const [state, setState] = useState<Omit<IPermissionPolicy, 'id'>>({
        policyName: '',
        dashboard: false,
        aimVision: false,
        hr: false,
        fuel: false,
        machinery: false,
        inventory: false,
        analytics: false,
        resources: false,
        contractors: false,
        capabilities: false,
        operations: false,
        procurement: false,
        configurations: false,
        food: false,
        kitchen: false,
        accommodation: false,
        organogram: false,
    })
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const { id } = useParams()
    const { singlePermissionPolicyTemplate } = useSelector((state: RootState) => state.roleTemplates)

    useEffect(() => {
        dispatch(getSingleRolePermissionPolicyTemplate(id))
        return () => {
            dispatch(clearSinglePermissionPolicyTemplate())
        }
    }, [id])

    useEffect(() => {
        singlePermissionPolicyTemplate && setState(singlePermissionPolicyTemplate)
    }, [singlePermissionPolicyTemplate])

    const handleToggle = (name: string) => {
        setState(prev => {
            const copy = structuredClone(prev)
            copy[name] = !copy[name]
            return copy
        })
    }

    const handleSubmit = async () => {
        const resp = await dispatch(editRolePermissionPolicyTemplate({ ...state, id: Number(id) }))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate(-1)
        }
    }

    return <>
        <NavBar />
        <PageWrapper>
            <H1WithBack arrow title='Edit Permission Policy Template ' />
            <Flex mt='16' width={screen.availWidth < 500 ? '100%' : '40%'} column gap="1rem" >
                <Input nomarg labelText='Template name' value={state.policyName} onChange={e => setState(prev => ({ ...prev, policyName: e.target.value }))} />
                {Object.keys(state).filter(p => !['policyName', 'id'].includes(p)).map((p, i) => <Flex key={i} width='100%' between  >
                    <H2>{p.toUpperCase()}</H2>
                    <ToggleButton
                        state={state[p] || false}
                        handleChange={handleToggle}
                        name={p}
                    />
                </Flex>)}
            </Flex>
        </PageWrapper>
        <PageFooter>
            <Flex gap='1rem'>
                <CancelBtn />
                <Button orange onClick={handleSubmit}>
                    Save
                </Button>
            </Flex>
        </PageFooter>
    </>
}